<template>
  <div class="card card-hover w-100">
    <div
      class="card-body d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3"
    >
      <div class="d-flex align-items-center gap-3 flex-grow-1">
        <div
          v-if="showIcons"
          class="settings-list-icon bg-primary-subtle rounded-3 d-flex align-items-center justify-content-center flex-shrink-0"
        >
          <ImageBlob
            v-if="tool.data.icon"
            class="settings-card-icon-image w-100 h-100 p-3"
            :imagePath="tool.data.icon"
          />
          <font-awesome-icon
            v-else
            :icon="['far', 'face-confused']"
            size="2x"
            class="text-primary"
          />
        </div>
        <ImageBlob
          v-else
          class="settings-list-image overflow-hidden flex-shrink-0"
          :imagePath="tool.data.image"
        />
        <div class="d-flex flex-column">
          <span class="fw-semibold">{{ tool.data.name }}</span>
          <small class="text-muted">
            {{ $t("settings.user") }} ({{ tool.data?.users?.length || 0 }})
          </small>
        </div>
      </div>
      <div
        v-if="isSuperAdmin || isAdmin"
        class="ms-md-auto"
      >
        <DropDownTools
          :id="tool.id"
          :show-settings="isSuperAdmin"
          :show-delete="isSuperAdmin"
          :show-users="isSuperAdmin || isAdmin"
          @settings="$emit('settings', tool)"
          @delete="$emit('delete', tool.id)"
          @users="$emit('users', tool.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import ImageBlob from "../smallComponents/ImageBlob.vue";
  import DropDownTools from "../smallComponents/DropDownTools.vue";

  export default {
    name: "ToolListItem",
    components: {
      ImageBlob,
      DropDownTools,
    },
    props: {
      tool: {
        type: Object,
        required: true,
      },
      showIcons: {
        type: Boolean,
        default: false,
      },
      isSuperAdmin: {
        type: Boolean,
        default: false,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["settings", "delete", "users"],
  };
</script>

<style scoped>
  .card-hover {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .card-hover:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
    z-index: 1;
  }

  .settings-list-image {
    width: 4rem;
    height: 4rem;
  }

  .settings-list-image :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .settings-list-icon {
    width: 4rem;
    height: 4rem;
  }

  .settings-card-icon-image :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>
